import { Autocomplete, TextField } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useQuery } from "react-query";
import { IdNameModel } from "services/organizationPortalClient";
import contextStore from "stores/contextStore";
import { useIntl } from "react-intl";

type SelectProfessionProps = {
  value: string[];
  onChange: (v: string[]) => void;
};

const SelectProfession = ({ onChange, value }: SelectProfessionProps) => {
  const { formatMessage: t } = useIntl();
  const { enrollmentService } = useGlobalContext();
  const { organization } = contextStore.useState();

  const { data, isFetching } = useQuery(
    ["enrollmentService.getProfessions", organization?.id],
    () => enrollmentService.getProfessions()
  );

  const handleChangeMultiple = (_: any, values: IdNameModel[]) => {
    onChange(values.map((v) => v.id!));
  };

  const options =
    data?.data?.sort((a, b) => a.name!.localeCompare(b.name!)) ?? [];

  return (
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={(option) => option.name ?? "?"}
      value={options.filter((r) => value.includes(r.id!) ?? false)}
      onChange={handleChangeMultiple}
      loading={isFetching}
      size="small"
      renderInput={(params) => (
        <TextField {...params} label={t({ id: "professions" })} size="small" />
      )}
    />
  );
};

export default SelectProfession;
